<template>
  <div>
    <form class="form_padrao pt-2" action @submit.prevent="acao">
      <div class="form-row">
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="nome"
            id="nome"
            v-model="card.nomeCartao"
            required
          />
          <label for="nome">Nome do Titular (Idêntico do Cartão)</label>
        </div>
        <div class="form-group flutuante col-md-12 col-lg-6">
          <input
            type="text"
            name="numerocartao"
            id="numerocartao"
            @keyup="checkFlag"
            v-model="card.numeroCartao"
            required
            v-mask="['#### #### #### ####']"
          />

          <label for="numerocartao">Número do Cartão</label>
          <i for="numerocartao" class="flag">
            <img src="@/assets/img/elo.svg" alt v-if="bandeira == 'elo'" />
            <img src="@/assets/img/visa.svg" alt v-if="bandeira == 'visa'" />
            <img
              src="@/assets/img/mastercard.svg"
              alt
              v-if="bandeira == 'mastercard'"
            />
            <img
              src="@/assets/img/hipercard.svg"
              alt
              v-if="bandeira == 'hipercard'"
            />
          </i>
        </div>
        <div class="form-group flutuante col-md-6 col-lg-3">
          <the-mask
            type="text"
            name="anomes"
            id="anomes"
            required
            v-model="card.dataExpiracaoCartao"
            :mask="['##/##']"
          />
          <label for="numerocartao">Mês/Ano</label>
        </div>
        <div class="form-group flutuante col-md-6 col-lg-3">
          <the-mask
            type="text"
            name="nomes"
            id="nomes"
            required
            :mask="['###', '####']"
            v-model="card.codigoValidacaoCartao"
          />
          <label for="numerocartao">CCV</label>
        </div>
        <div class="form-group col-md-12">
          <label class="small mb-1" for="parcelas">Parcelamento</label>
          <select
            name="mvTipo"
            id="mvTipo"
            v-model="card.parcelamento"
            placeholder="Selecione"
          >
            <option value selected disabled>Selecione...</option>
            <option value="1">1x</option>
            <option value="2">2x</option>
            <option value="3">3x</option>
          </select>
        </div>
      </div>
      <div class="form-row d-flex flex-row justify-content-end align-items-end">
        <div
          class="form-group col-md-12 d-flex flex-row justify-content-end align-items-end"
        >
          <button
            type="submit"
            class="btn btn-verde p-0 fit-content"
            :disabled="loading"
          >
            <span
              class="spinner-grow spinner-grow-sm pr-2"
              role="status"
              aria-hidden="true"
              v-show="loading"
            ></span>
            <span v-if="loading">Aguarde, processando pagamento</span>
            <span v-else>Finalizar Pagamento</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { detectFlag } from "../../helpers.js";
export default {
  name: "CartaoCredito",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      payment: 1,
      curso: [],
      produto: {
        nome: "Checkout",
        id: "checkout",
      },
      listaCredito: [],
      card: {
        nomeCartao: "",
        numeroCartao: "",
        dataExpiracaoCartao: "",
        codigoValidacaoCartao: "",
        parcelamento: 1,
        dataaceite: new Date(),
        iporigem: "",
        browserdata: navigator.appVersion,
        aceite: false,
        datarevisaO_TERMO: new Date(),
      },
      bandeira: "",
    };
  },
  methods: {
    checkFlag() {
      if (this.card.numeroCartao.replace(/\s/g, "").length >= 14) {
        this.bandeira = detectFlag(this.card.numeroCartao.replace(/\s/g, ""));
      } else {
        this.bandeira = "";
      }
    },
    acao() {
      this.$emit("click", {
        props: {
          dataCard: this.card,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
.alert {
  line-height: 1.4;
  strong {
    font-weight: 700;
  }
}
.flag {
  position: absolute;
  top: 10px;
  right: 15px;
  img {
    width: 35px;
    height: 35px;
  }
}
.item-card {
  text-align: center;
  width: 100%;
  border-radius: 5px;
  background: #fff;
  padding: 25px 10px;
  justify-content: space-between;
  align-items: center;
  color: #6c757d;
  margin-right: 5px;
  .item-card-valor {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #000;
  }
  .item-card-titulo {
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
.relatorio-card-link {
  @include transition-all();
}
hr {
  color: #e9ecef !important;
  border-color: #e9ecef !important;
  border-width: 2px;
}
</style>
